import _ from 'lodash';

const isDeepEmpty = (value: unknown): boolean => {
    if (_.isNil(value)) return true;

    if (_.isString(value)) return _.isEmpty(value.trim());

    if (_.isArray(value)) return value.every(isDeepEmpty);

    if (_.isObject(value)) return _.every(value, isDeepEmpty);

    return false; // numbers, booleans are not empty
};

export const isArrayDeepEmpty = (arr: any[]) => _.isArray(arr) && (arr.length === 0 || arr.every(isDeepEmpty));
